import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/variants',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/my-styles/variants' ||
      location.pathname === '/my-styles/variants/'
    ) {
      throw redirect({ to: '/my-styles/variants/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/VariantsLayout'),
    'VariantsLayout',
  ),
});
